/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-key */
import React from 'react';
import './projectsPage.css';
import Header from '../components/header';
import Footer from '../components/footer';
import HrAgent from '../components/hrAgent';

function ProductHrAgent() {
  return (
    <div className="main">
      <Header />
      <HrAgent />
      <Footer />
    </div>
  );
}

export default ProductHrAgent;
